const { Route } = require('react-router-dom');
const { lazyWithRetry } = require('components/lazyWithRetry');

const ConsolidatedReports = lazyWithRetry(() => import('../../../modules/admin/consolidatedReports'));

export default (
  <Route
    path="consolidated-reports/"
    element={<ConsolidatedReports />}
  />
);
